module.exports = __webpack_public_path__ + "assets/img/report-act-btn-1.597c87e1.png";